const pageNameKey = "unfilteredMissingNodesPillButton";

export const unfilteredMissingNodesPillButtonEn = {
  [pageNameKey]: {
    indicatorIconAltText: "Indicator Icon",
    barsIconAltText: "Bars Arrow Icon",
  },
};

export const unfilteredMissingNodesPillButtonPtBr = {
  [pageNameKey]: {
    indicatorIconAltText: "Ícone indicador",
    barsIconAltText: "Ícone de barra com seta",
  },
};

export const unfilteredMissingNodesPillButtonDe = {
  [pageNameKey]: {
    indicatorIconAltText: "Indikator-Icon",
    barsIconAltText: "Balkenpfeil-Icon",
  },
};

export const unfilteredMissingNodesPillButtonZhHans = {
  [pageNameKey]: {
    indicatorIconAltText: "指示器图标",
    barsIconAltText: "条形箭头图标",
  },
};

export const unfilteredMissingNodesPillButtonIt = {
  [pageNameKey]: {
    indicatorIconAltText: "Icona Indicatore",
    barsIconAltText: "Icona Freccia Barre",
  },
};

export const unfilteredMissingNodesPillButtonEs = {
  [pageNameKey]: {
    indicatorIconAltText: "Icono indicador",
    barsIconAltText: "Icono de barras y flecha",
  },
};

export const unfilteredMissingNodesPillButtonNl = {
  [pageNameKey]: {
    barsIconAltText: "Staafpijl-pictogram",
    indicatorIconAltText: "Indicatorpictogram",
  },
};

export const unfilteredMissingNodesPillButtonTr = {
  [pageNameKey]: {
    barsIconAltText: "Çubuklar Ok Simgesi",
    indicatorIconAltText: "Gösterge Simgesi",
  },
};
